import React, { useContext, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SideMenu from "./components/SideMenu/SideMenu";
import Header from "./components/Header/Header";
import DateCart from "./components/DateCart.js/DateCart";
import GraphCart from "./components/GraphCart/GraphCart";
import Customer from "./components/Customer/Customer";
import SingleCustomer from "./components/Single Customer/SingleCustomer";
import SingleCustomerTranscript from "./components/transcriptData/SingleCustomerTranscript";
import Dashboard from "./components/Dashboard/Dashboard";
import { Context } from "./utils/context";
import Demo from "./components/Demo/Demo";
import SingleTranscript from "./components/Demo/SingleTranscript";

function Container() {
  const { action } = useContext(Context);
  useEffect(() => {
    const mainArea = document.getElementById("mainArea");
    mainArea.scroll(0, 0);
  });
  return (
    <>
      <BrowserRouter>
        <div className="container">
          <div className="sideMenu">
            <SideMenu />
          </div>
          <div className="header">
            <Header />
          </div>
          <div className="contentArea">
            <>
              <div className="mainArea" id="mainArea">
                <Routes>
                  <Route index element={<Demo />} />
                  <Route path="/customer" element={<Customer />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route
                    path="/customer/transcript/:id"
                    element={<SingleCustomerTranscript />}
                  />
                  <Route path="/customer/:id" element={<SingleCustomer />} />
                  <Route
                    path="/transcript"
                    Component={(props) => <SingleTranscript {...props} />}
                  />
                </Routes>
              </div>
              {action === "customer" || action === "agent" ? (
                <div className="leftArea">
                  <GraphCart />
                  <DateCart />
                </div>
              ) : (
                <></>
              )}
            </>
          </div>
        </div>
      </BrowserRouter>
    </>
  );
}

export default Container;
